import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "flex items-center justify-between q-mb-lg" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle" }, "Universal naming", -1)
const _hoisted_4 = { style: {"width":"400px"} }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  class: "cursor-pointer",
  style: {"margin-left":"40px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_center = _resolveComponent("center")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_center, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_q_spinner, {
            color: "primary",
            size: "3em",
            thickness: 2
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_q_btn, {
            class: "q-btn__main-size text-weight-bold",
            onClick: _ctx.addRule,
            color: "primary",
            unelevated: "",
            "no-caps": "",
            "icon-right": _ctx.heroOutline24Plus,
            label: "Add naming"
          }, null, 8, ["onClick", "icon-right"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tdsRules, (rule, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex items-center q-mb-md background-gray q-pa-lg"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_input, {
                dense: "",
                outlined: "",
                label: _ctx.$t('your_naming'),
                "stack-label": "",
                "model-value": _ctx.getFullNaming(rule, index),
                class: "q-pa-none q-mr-md q-field--gray",
                "onUpdate:modelValue": 
            naming => _ctx.updateField({ ...rule, naming }, index)
          ,
                "error-message": _ctx.errors?.tdsRules?.[index]?.naming,
                error: !!_ctx.errors?.tdsRules?.[index]?.naming
              }, null, 8, ["label", "model-value", "onUpdate:modelValue", "error-message", "error"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_input, {
                dense: "",
                outlined: "",
                label: _ctx.$t('offer_link'),
                "stack-label": "",
                class: "q-pa-none q-field--gray",
                placeholder: "https://keitaro.io/{sub1}?sub2={sub2}&sub3={sub3}&sub4={sub4}&sub5={click_id}",
                "model-value": rule.redirectUrl,
                "onUpdate:modelValue": 
            redirectUrl => _ctx.updateField({ ...rule, redirectUrl }, index)
          ,
                "error-message": 
            _ctx.errors?.tdsRules?.[index]?.redirectUrl || _ctx.errors?.tdsRules
          ,
                error: 
            !!_ctx.errors?.tdsRules?.[index]?.redirectUrl || !!_ctx.errors?.tdsRules
          
              }, null, 8, ["label", "model-value", "onUpdate:modelValue", "error-message", "error"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_q_icon, {
                name: _ctx.heroOutline24Trash,
                onClick: ($event: any) => (_ctx.deleteRule(index))
              }, null, 8, ["name", "onClick"])
            ])
          ]))
        }), 128)),
        _createVNode(_component_q_btn, {
          "no-caps": "",
          label: _ctx.$t('save'),
          type: "submit",
          color: "primary",
          class: "q-mt-lg q-btn__main-size",
          unelevated: "",
          onClick: _ctx.save
        }, null, 8, ["label", "onClick"])
      ]))
}